import store from '../../utils/localStorageFallback';

function removeHash() {
  // eslint-disable-next-line no-restricted-globals
  history.pushState('', document.title, window.location.pathname + window.location.search);
}

const hideSections = () => {
  const storeVersion = store('version');
  const allSections = document.querySelectorAll('.investors, .investor, .adviser');
  let sectionsToHide;

  for (let i = 0; i < allSections.length; i += 1) {
    allSections[i].classList.add('u-hidden');
  }

  if (storeVersion === 'investor') {
    sectionsToHide = document.querySelectorAll(`.${storeVersion}, .investors`);
  } else {
    sectionsToHide = document.getElementsByClassName(`${storeVersion}`);
  }

  for (let i = 0; i < sectionsToHide.length; i += 1) {
    sectionsToHide[i].classList.remove('u-hidden');
  }
};

const forceRoleRedirect = () => {
  const user = store('version');

  if (document.body.classList.contains('adviser') || document.body.classList.contains('investor')) {
    // in a restricted page/ post / product.
    if (!document.body.classList.contains(user)) {
      // redirect to home if now allowed.
      document.location.href = '/';
    }
  }
};

const clientPlanningReload = () => {
  if (document.body.classList.contains('page-template-client-planning')) {
    document.location.reload();
  }
};

const resourceCentreReload = () => {
  const path = document.location.pathname;

  if (path === '/resources/') {
    document.location.reload();
  }
};

const modal = document.querySelector('.modal');
const roleSelect = document.getElementsByClassName('modal-content-role-select')[0];

const toggleModal = () => {
  const currentState = modal.style.display;
  // If modal is visible, hide it. Else, display it.
  if (currentState === 'none') {
    modal.style.display = 'block';
  } else {
    modal.style.display = 'none';
  }
};

const utilityNavButtons = document.querySelectorAll('.utilityNav-button a');

if (window.location.hash) {
  const hash = window.location.hash.substring(1);
  if (/content-adviser|content-investor/.test(hash)) {
    const version = hash.replace('content-', '');
    const versions = ['adviser', 'investor'];
    if (versions.includes(version)) {
      const allButtons = document.querySelectorAll(`.utilityNav-button.${version} a`);
      allButtons.forEach(btn => {
        const parent = btn.parentNode;
        const grandparent = parent.parentNode;

        grandparent.querySelectorAll('li').forEach(li => {
          li.classList.remove('active');
        });

        parent.classList.add('active');
      });

      store(`${version}-confirmed`, 'true');
      store('version', version);

      hideSections();
      forceRoleRedirect();
      resourceCentreReload();
      clientPlanningReload();
    }

    removeHash();
  }
}

let storeVersion;

if (utilityNavButtons.length > 0) {
  storeVersion = store('version');
  const activeButton = document.querySelectorAll(`.utilityNav-button.${storeVersion}-btn a`);
  activeButton.forEach(button => {
    const activeParent = button.parentNode;
    const activeGrandparent = activeParent.parentNode;
    button.classList.add('active');

    activeGrandparent.querySelectorAll('li').forEach(li => {
      li.classList.remove('active');
    });

    activeParent.classList.add('active');
  });

  utilityNavButtons.forEach(button => {
    // eslint-disable-next-line consistent-return
    button.addEventListener('click', e => {
      e.preventDefault();
      const { target } = e;
      const listItem = target.parentNode;
      let version;

      if (listItem.classList.contains('adviser-btn')) {
        version = 'adviser';
      }
      if (listItem.classList.contains('investor-btn')) {
        version = 'investor';
      }
      if (listItem.classList.contains('institutional-investor-btn')) {
        version = 'institutional-investor';
      }

      const allButtons = document.querySelectorAll(`.utilityNav-button.${version}-btn a`);
      allButtons.forEach(btn => {
        const parent = btn.parentNode;
        const grandparent = parent.parentNode;

        grandparent.querySelectorAll('li').forEach(li => {
          li.classList.remove('active');
        });

        parent.classList.add('active');
      });

      storeVersion = store('version');

      if (storeVersion === version) {
        return false;
      }

      if (store(`${version}-confirmed`)) {
        if (version === 'institutional-investor') {
          // eslint-disable-next-line no-undef
          window.location.href = `${deepsea_investments.institutional_website_link}#content-${version}`;
          return false;
        }

        store('version', version);

        hideSections();
        forceRoleRedirect();
        resourceCentreReload();
        clientPlanningReload();

        return false;
      }

      toggleModal();
      const confirmScreen = document.getElementsByClassName(`${version}-confirm`)[0];
      const confirmButton = document.getElementsByClassName(`${version}-confirm-button`)[0];
      roleSelect.style.display = 'none';
      confirmScreen.style.display = 'block';

      // eslint-disable-next-line consistent-return
      confirmButton.addEventListener('click', () => {
        store(`${version}-confirmed`, 'true');

        if (version === 'institutional-investor') {
          // eslint-disable-next-line no-undef
          window.location.href = `${deepsea_investments.institutional_website_link}#content-${version}`;
          return false;
        }

        store('version', version);

        hideSections();
        forceRoleRedirect();
        resourceCentreReload();
        clientPlanningReload();

        modal.style.display = 'none';
        confirmScreen.style.display = 'none';
      });
    });
  });
}

const utilityNav = document.querySelector('.utilityNav--desktop');
const siteHeader = document.querySelector('.site-header');

if (utilityNav !== null) {
  const siteHeaderStart = siteHeader.offsetTop;
  const mqFromTablet = window.matchMedia('(max-width: 1023px)');

  window.addEventListener('scroll', () => {
    const scrollPosition = window.scrollY ?? window.pageYOffset;

    if (!mqFromTablet.matches) {
      if (scrollPosition >= siteHeaderStart) {
        siteHeader.style.top = `0px`;
        if (!siteHeader.classList.contains('fixed--withUtilityNav')) {
          siteHeader.classList.add('fixed--withUtilityNav');
        }
      } else {
        siteHeader.style.top = `${siteHeaderStart - scrollPosition}px`;
        if (siteHeader.classList.contains('fixed--withUtilityNav')) {
          siteHeader.classList.remove('fixed--withUtilityNav');
        }
      }
    }
  });

  window.addEventListener('resize', () => {
    if (mqFromTablet.matches) {
      siteHeader.style.top = null;
    }
  });

  const utilityNavMobileButtons = document.querySelectorAll(
    '.utilityNav--mobile .utilityNav-button a',
  );

  utilityNavMobileButtons.forEach(button => {
    const el = button;
    if (el.textContent === 'Retail investor') {
      el.textContent = 'Investor';
    }

    if (el.textContent === 'Institutional investor') {
      el.textContent = 'Institutional';
    }
  });
}
